import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const RewardStarLight: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, s.rewardsStar)}
    width="17"
    height="16"
    data-icon={icon}
  >
    <path
      d="M13.753 16l-1.394-5.921L17 6.095l-6.113-.514L8.5 0 6.113 5.581 0 6.095l4.64 3.984L3.248 16 8.5 12.858z"
      fill="#000"
      fillRule="nonzero"
    />
  </svg>
);

export default RewardStarLight;
